<template>
  <header>
    <main-nav />
  </header>
</template>

<script>
// import DeliveryLaunchCTA from '@/components/DeliveryLaunch'
import MainNav from '@/components/Navigation'

export default {
  name: 'Header',
  components: {
    // 'delivery-launch-cta': DeliveryLaunchCTA,
    'main-nav': MainNav
  }
}
</script>

<style lang="scss" scoped>
  .back {
    &:hover {
      svg {
        fill: $green;
      }
    }
  }
</style>
